import React from 'react'
import { History } from 'history'

export default React.createContext<History | undefined>(undefined)